import { getApiConfig } from "../authHelper"
import { get, post, del } from "../api_helper"
import * as url from "../url_helper"
import axios from "axios"


export const getAllChequeTemplates = () => {
    return get(`${url.CHEQUE_TEMPLATE}`, getApiConfig())
}

const buildTemplateFormData = (data, imageFile, sourceTemplateId) => {
    const formData = new FormData()
    formData.append("bankName", data.bankName)
    formData.append("leaf", JSON.stringify(data.leaf))
    formData.append("fields", JSON.stringify(data.fields))
    if (imageFile) formData.append("image", imageFile)
    if (sourceTemplateId) formData.append("sourceTemplateId", sourceTemplateId)
    return formData
}

const getMultipartConfig = () => {
    const config = getApiConfig(true) || {}
    const headers = { ...(config.headers || {}) }
    delete headers["Content-Type"]
    return { ...config, headers }
}

export const createChequeTemplate = async (data, imageFile, sourceTemplateId) => {
    const response = await axios.post(
        `${url.API_URL}${url.CHEQUE_TEMPLATE}`,
        buildTemplateFormData(data, imageFile, sourceTemplateId),
        getMultipartConfig()
    )
    return response.data
}

export const updateChequeTemplate = async (id, data, imageFile) => {
    const response = await axios.put(
        `${url.API_URL}${url.CHEQUE_TEMPLATE}/${id}`,
        buildTemplateFormData(data, imageFile),
        getMultipartConfig()
    )
    return response.data
}

export const deleteChequeTemplate = id => {
    return del(`${url.CHEQUE_TEMPLATE}/${id}`, getApiConfig())
}

export const getCustomerChequeTemplates = () => {
    return get(`${url.CHEQUE_TEMPLATE}/customer`, getApiConfig())
}

export const makeChequeTemplateGlobal = id => {
    return post(`${url.CHEQUE_TEMPLATE}/${id}/make-global`, {}, getApiConfig())
}
